module.exports = __webpack_public_path__ + "img/ios_download_btn_en.6c5f99ee.svg";